import React from 'react'
import SCWebhooksComponent from './SCWebhooks'

export const SCWebhooks = () => <SCWebhooksComponent />
